import { Component, OnInit } from '@angular/core';
import { NgxSmartModalService, NgxSmartModalComponent } from 'ngx-smart-modal';
import { ToastrService } from 'ngx-toastr';
import { ServiceLogService } from '@app/services/serviceLog.service';

@Component({
  selector: 'app-service-log-remove-modal',
  templateUrl: './service-log-remove-modal.component.html',
  styleUrls: ['./service-log-remove-modal.component.css']
})
export class ServiceLogRemoveModalComponent implements OnInit {

  constructor(
    public ngxSmartModalService: NgxSmartModalService,
    private toastr: ToastrService,
    private serviceLogService: ServiceLogService
  ) { }

  serviceLogId: number
  modalName: string = 'serviceLogRemoveModal'

  clear(): void {
    this.serviceLogId = null
    this.ngxSmartModalService.get(this.modalName).removeData();
  }

  remove(): void {
    if (!this.serviceLogId) {
      return;
    }

    this.serviceLogService.delete(this.serviceLogId).subscribe(
      () => {
        this.toastr.success('Serviceloggen har tagits bort.')
        this.ngxSmartModalService.get(this.modalName).removeData()
        this.ngxSmartModalService.setModalData({ success: true }, this.modalName)
        this.ngxSmartModalService.close(this.modalName)
      },
      (error) => {
        this.toastr.error('Det gick inte att ta bort serviceloggen.');
      },
      () => {
        //complete
      }
    );
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.ngxSmartModalService.getModal(this.modalName).onOpen.subscribe((modal: NgxSmartModalComponent) => {
        this.serviceLogId = modal.getData()
    });
  }

}
